import { NotFoundComponent } from './NotFoundComponent';
export default NotFoundComponent;
